import Scroller from '@/Utils/Scroller';

const highlightClassName = 'is-highlighted';
const deHighlightClassName = 'is-dehighlighted';

function _highlight(el, autoScroll, defaultOffset) {
    el.classList.add(highlightClassName);
    if (autoScroll) {
        // fix for navigation bar and project setup progress bar
        if (defaultOffset !== 0) {
            // When scrolling, this amount of distance is kept from the edges of the container:
            const edgeOffset = 9;
            const elYPosition = el.getBoundingClientRect().y;
            Scroller.toY(elYPosition - defaultOffset - edgeOffset);
        }
        else {
            Scroller.to(el);
        }
    }
}

function _highlightParent(parent, el, autoDeHighlight, autoScroll, defaultOffset) {
    _highlight(parent, autoScroll, defaultOffset);

    if (autoDeHighlight) {
        _startListening(el, parent);
    }
}

function _startListening(el, parent = null) {
    if (!parent) {
        parent = el;
    }

    el.addEventListener('focus', _deHighlight.bind(this, parent), { once: true });
    el.addEventListener('click', _deHighlight.bind(this, parent), { once: true });
    el.addEventListener('dragover', _deHighlight.bind(this, parent), { once: true });
}

function _deHighlight(el) {
    el.classList.remove(highlightClassName);
    el.classList.add(deHighlightClassName);
}

export default {
    highlight(el, autoDeHighlight = false, autoScroll = false) {
        _highlight(el, autoScroll);

        if (autoDeHighlight) {
            _startListening(el);
        }
    },
    highlightParentOf(el, autoDeHighlight = false, autoScroll = false, defaultOffset = 0) {
        const parent = el.closest(['.gfu-field, .js-highlighter']);

        if (parent) {
            _highlightParent(parent, el, autoDeHighlight, autoScroll, defaultOffset);
        }
    },
    getDefaultOffset(elements) {
        return [...document.querySelectorAll(elements)]
            .reduce((acc, curr) => {
                acc += curr.getBoundingClientRect().height;
                return acc;
            }, 0);
    },
};
